import React from 'react';
import './InputField.css';

interface InputFieldProps {
  label?: string;
  placeholder?: string;
  helper?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  min?: string;
  required?: boolean;
  error?: string;
  inputMode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
  maxLength?: number;
}

const InputField: React.FC<InputFieldProps> = ({ 
  label, 
  placeholder, 
  helper, 
  value, 
  onChange, 
  type = "text",
  min,
  required = false,
  error,
  inputMode,
  maxLength = 10
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    // For numeric inputs, limit to maxLength digits
    if (type === 'number' || inputMode === 'numeric' || inputMode === 'decimal') {
      // Remove non-digit characters and limit to maxLength
      const numericValue = inputValue.replace(/\D/g, '').slice(0, maxLength);
      e.target.value = numericValue;
    }
    
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="input-field">
      {label && <label>{label}</label>}
      <input 
        type={type} 
        placeholder={placeholder} 
        value={value} 
        onChange={handleChange}
        min={min}
        required={required}
        inputMode={inputMode}
        maxLength={type === 'text' ? maxLength : undefined}
        className={error ? 'input-error' : ''}
      />
      {error && <p className="error-message">{error}</p>}
      {helper && <p className="helper">{helper}</p>}
    </div>
  );
};

export default InputField;
